import { html } from 'lit';
import { view } from '../factory.js';
import { useMemo, useObservedValue } from '../hooks/index.js';
import { ObservableValue } from '../shared-state/index.js';
import { DefaultFormatter, Formatter } from '../formatters/core.js';

type Content<T> = T | ObservableValue<T>;

class Props {
  content: Content<unknown> = '';
  formatter: Formatter<unknown> = new DefaultFormatter();
}

export const [Text] = view('esui-demo-text', {
  Props,
  template({ content, formatter }) {
    const value = useObservedValue(content);
    const text = useMemo(() => formatter.format(value), [value]);

    return html`${text}`;
  },
  mapBuilder: TextBuilder => <T>(
    content: Content<T>,
    formatter: Formatter<T> = Formatter.default
  ) => TextBuilder().content(content).formatter(formatter),
});
